export const path = "/aluna-active-projects";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "PROYECTOS ACTIVOS",
  section: "ALUNA",
  group: null,
  order: 8,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
    "aluna-afiliado",
  ],
};
